<header class="fixed-top" *ngIf="isComponentVisible()">
  <nav class="navbar navbar-expand-lg navbar-dark bg-primary fixed-navbar w-100 m-0 p-0 border border-top-0 border-right-0 border-left-0 border-secondary rounded-0">
    <a class="navbar-brand ms-4 me-4" [routerLink]="['/home']">
      <div class="py-1 px-1 ml-4">
          <img style="height: 38px;" src="/assets/images/new-logo.png" alt="Logo Grupo Moura"/>
      </div>
    </a>
      <button class="navbar-toggler mr-3 navbar-menu" type="button" (click)="isMenuCollapsed = !isMenuCollapsed">
      <span class="navbar-toggler-icon"></span>
    </button>

    <div [ngbCollapse]="isMenuCollapsed" class="collapse navbar-collapse ml-3 container-fluid">
      <ul class="nav navbar-nav mr-auto flex-column flex-lg-row">
        <li class="nav-item clickable ml-2 navbar-menu" *ngFor="let item of menuItems" ngbDropdown>
            <!-- START Menu link button -->
            <a *ngIf="!item.submenu && authService.temPermissao(item.permissao)" class="nav-link" [routerLink]="item.link"  routerLinkActive="active-link">
              <i [ngClass]="item.icon"></i> <span class="ml-1">&nbsp;{{item.text}} </span>
            </a>

            <!-- START Dropdown toggle-->
            <a *ngIf="item.submenu && authService.temPermissao(item.permissao)" ngbDropdownToggle class="nav-link dropdown-toggle" id="dropdown" role="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                <i [ngClass]="item.icon"></i> <span class="ml-1">&nbsp;{{item.text}} </span>
            </a>
            <div ngbDropdownMenu aria-labelledby="dropdown">
              <div *ngFor="let subitem of item.submenu" >
                <a class="dropdown-item" *ngIf="authService.temPermissao(subitem.permissao)" ngbDropdownItem [routerLink]="subitem.link" [title]="subitem.text" >
                  <span>{{subitem.text}}</span>
                </a>
              </div>
            </div>
        </li>
      </ul>
      <div class="navbar-nav d-flex me-3">
        <div class="div-detalhe-letra">
          <div class="letra-detalhe-menu">{{ letraNomeUser | uppercase }}</div>
        </div>
        <div class="mr-4">
          <div ngbDropdown class="d-inline-block clickable">
            <a ngbDropdownToggle class="nav-link dropdown-toggle" id="dropdown" role="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                {{ user.name }}
            </a>
            <div ngbDropdownMenu aria-labelledby="dropdown">
                <button class="btn btn-light dropdown-menu-amm" ngbDropdownItem (click)="modalAlterarSenha(content)"><i class="fa fa-unlock-alt"></i> Redefinir senha</button>
                <button class="btn btn-light dropdown-menu-amm" ngbDropdownItem (click)="logout()"><i class="fa fa-sign-out"></i> Sair</button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </nav>
</header>

<!-- MODAL PARA CADASTRAR/ALTERAR OS ATENDIMENTOS -->
<ng-template #content let-closed="close" let-dismiss="dismiss">
  <form [formGroup]="form" autocomplete="off" (ngSubmit)="alterarSenha()">
    <div class="form-header">
      <h3 class="form-header-title">ALTERAR SENHA</h3>
      <button type="button" class="btn btn-primary mr-2 btn-fechar" (click)="dismiss('click')">
        <span aria-hidden="true">&times;</span>
     </button>
    </div>
   <div class="modal-body">
        <div class="row">
          <div class="col-12 mt-1">
            <label class="required label-control">Senha atual</label>
            <input type="password" formControlName="senhaAtual" class="form-control" placeholder="Informe sua senha atual" autofocus required>

            <app-vmessage *ngIf="form.get('senhaAtual').errors?.required && (form.submitted || form.get('senhaAtual').touched)"
                text="Senha atual é Obrigatória!">
            </app-vmessage>
          </div>
          <div class="col-12 mt-3">
            <label class="required label-control">Nova senha</label>
            <input formControlName="novaSenha" class="form-control" placeholder="Informe sua nova senha" type="password">

            <app-vmessage *ngIf="form.get('novaSenha').errors?.required && (form.submitted || form.get('novaSenha').touched)"
                    text="Campo Obrigatório">
            </app-vmessage>
          </div>
          <div class="col-12 mt-3">
            <label class="required label-control">Confirme a nova senha</label>
            <input formControlName="passwordConfirmation" class="form-control" placeholder="Confirme sua nova senha" type="password">

          <app-vmessage
            *ngIf="form.get('passwordConfirmation').errors?.required && (form.submitted || form.get('passwordConfirmation').touched)"
            text="Campo Obrigatório">
          </app-vmessage>
          <app-vmessage
              *ngIf="form.get('passwordConfirmation').errors?.equalTo && (form.submitted || form.get('passwordConfirmation').touched)"
              text="As senhas informadas não são iguais.">
          </app-vmessage>
          </div>
      </div>
    </div>
    <div class="modal-footer">
        <button type="button" ngbAutofocus class="btn btn-secondary" (click)="dismiss('click')"> <i class="fa fa-times" aria-hidden="true"></i>&nbsp; Cancelar</button>
        <button type="submit" class="btn btn-primary" [disabled]="form.invalid"> <i class="fa fa-check" aria-hidden="true"></i>&nbsp;Salvar</button>
    </div>
  </form>
</ng-template>
